// Code generated by Slice Machine. DO NOT EDIT.

import dynamic from 'next/dynamic'

export const components = {
  activity_carousel: dynamic(() => import('./Activities')),
  body: dynamic(() => import('./SimpleContent')),
  card_grid: dynamic(() => import('./CardGrid')),
  category_list: dynamic(() => import('./CategoryList')),
  content_with_hexagon_images: dynamic(() => import('./HeroContent')),
  frequently_asked_questions: dynamic(
    () => import('./FrequentlyAskedQuestions')
  ),
  location_tag_cloud: dynamic(() => import('./LocationTagCloud')),
  map: dynamic(() => import('./Map')),
  multi_column: dynamic(() => import('./MultiColumn')),
  review_carousel: dynamic(() => import('./Reviews')),
  spacer: dynamic(() => import('./Spacer'))
}
